// extracted by mini-css-extract-plugin
export default {"contents":"GF-z","sectionHeading":"HF-z"};